import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=4db63696&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./answer.vue?vue&type=style&index=0&id=4db63696&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db63696",
  null
  
)

export default component.exports